import { render, staticRenderFns } from "./r-smart-offer-bundle-ancient-treasure.vue?vue&type=template&id=153f6d3d&scoped=true"
import script from "./r-smart-offer-bundle-ancient-treasure.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-ancient-treasure.vue?vue&type=script&lang=js"
import style0 from "./r-smart-offer-bundle-ancient-treasure.vue?vue&type=style&index=0&id=153f6d3d&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f6d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153f6d3d')) {
      api.createRecord('153f6d3d', component.options)
    } else {
      api.reload('153f6d3d', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-ancient-treasure.vue?vue&type=template&id=153f6d3d&scoped=true", function () {
      api.rerender('153f6d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-ancient-treasure/r-smart-offer-bundle-ancient-treasure.vue"
export default component.exports